// Qualquer tela pode chamar o Secretário (ex.: sugestões do "Sobre você" ou o
// microfone central). O chrome ouve este evento e abre a conversa dele; a
// intenção (texto pronto, começar ouvindo) viaja até a tela da conversa.
export const ASSISTANT_OPEN_EVENT = 'secretario:assistant';
export const ASSISTANT_ROUTE = '/conversas/secretario';

/** O lugar do Perto de onde a pessoa pediu: o Secretário fala com aquela unidade. */
export type AssistantPlaceRef = { id: string; name: string; where: string | null };

export type AssistantOpenDetail = {
  prefillText?: string;
  listen?: boolean;
  lugar?: AssistantPlaceRef;
};

let pendingIntent: AssistantOpenDetail | null = null;

export function openAssistant(prefillText?: string, lugar?: AssistantPlaceRef) {
  window.dispatchEvent(
    new CustomEvent<AssistantOpenDetail>(ASSISTANT_OPEN_EVENT, {
      detail: { ...(prefillText ? { prefillText } : {}), ...(lugar ? { lugar } : {}) },
    }),
  );
}

export function setAssistantIntent(intent: AssistantOpenDetail): void {
  pendingIntent = intent;
}

/** Lida uma única vez pela tela da conversa ao abrir. */
export function takeAssistantIntent(): AssistantOpenDetail | null {
  const intent = pendingIntent;
  pendingIntent = null;
  return intent;
}
